import { createContext, useState } from "react";

export const DataContext = createContext();
const { Provider } = DataContext;

const DataContextProvider = ({ children }) => {
    const [data, setData] = useState({
        specialties: [],
        institution_types: [],
        promoters: [],
        // si se utilizan mas elementos de UI, mover a otro Context
        snackbar_status: {
            open: false,
            message: ''
        }
    });
    
    return (
        <Provider value={{ data, setData }}>
            { children }
        </Provider>
    );
};

export default DataContextProvider;